import axios from 'axios';
import urls from '../../config/urls';
import config from '../../config/config';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;

const courseLandingPagePath = '/content/landing';

export async function getCourseLandingPageBySlug(slug) {
 return await axios.get(`${urls.hubUIApiRoot}${courseLandingPagePath}/slug/${slug}`, { timeout: config.wpTimeout });
}